import type { FieldErrors, FieldValues } from "react-hook-form";

export const handleErrors = <TFieldValues extends FieldValues>(
  errors: FieldErrors<TFieldValues>,
  name: string,
) => {
  if (!errors || typeof errors !== "object") {
    return false;
  }

  const path = name.split(".");
  const [first, index, ...rest] = path;
  const error = errors?.[first];

  if (!first || !error) {
    return false;
  }

  let currentError;

  if (Array.isArray(error)) {
    const numericIndex = parseInt(index, 10);
    if (isNaN(numericIndex) || numericIndex >= error.length) {
      return false;
    }
    currentError = error[numericIndex];
  } else if (index) {
    return false;
  } else {
    currentError = error;
  }

  for (const key of rest) {
    if (!currentError || typeof currentError !== "object") {
      return false;
    }
    if (!(key in currentError)) {
      return false;
    }
    currentError = currentError[key];
  }

  return !!currentError;
};
